import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'
import { login, getUserInfo, getUserAssetsData } from '../api/user'
import { setToken, removeToken, setUserInfo, removeUserInfo } from '../libs/util'
// import { Message } from 'element-ui'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: {}, // 用户信息
    userAssetsData: {}, // 用户账号资源数据
    token: '', // 登陆token
    systemMsgNum: 0,
    metaInfo: {
      title: '',
      keywords: '',
      description: ''
    },
    headBox600: false,
    top_400: false,
    showLoginBox: false,
    showBlackOver: 'none'
  },
  mutations: {
    CHANGE_META_INFO (state, metaInfo) {
      state.metaInfo = metaInfo
    },
    HEAD_BOX_600 (state, yes) {
      state.headBox600 = yes
    },
    top_400 (state, yes) {
      state.top_400 = yes
    },
    showBlackOver (state, display) {
      state.showBlackOver = display
    },
    showLoginBox (state, isShow) {
      state.showLoginBox = isShow
    },
    setToken (state, token) {
      state.token = token
      setToken(token)
    },
    setUserInfo (state, userInfo) {
      state.userInfo = userInfo
      setUserInfo(userInfo)
    },
    setUserAssetsData (state, data) {
      console.log(data)
      state.userAssetsData = data
    }
  },
  actions: {
    // 登录请求处理
    handleLogin ({ commit }, { account, password }) {
      account = account.trim()
      return new Promise((resolve, reject) => {
        login(account, password).then(response => {
          const res = response.data
          if (res.code === 0) {
            removeToken()
            commit('setToken', res.data.token)
          }
          resolve(response)
        }).catch(requestErr => {
          reject(requestErr)
        })
      })
    },
    // 退出登录
    handleLogOut ({ commit, state }) {
      return new Promise((resolve, reject) => {
        removeToken()
        removeUserInfo()
        commit('setToken', '')
        commit('setUserInfo', '')
        resolve()
      })
    },
    getUserInfo ({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUserInfo(state.token).then(response => {
          const res = response.data
          if (res.code === 0) {
            commit('setUserInfo', res.data)
          }
          resolve(response)
        }).catch(responseErr => {
          reject(responseErr)
        })
      })
    },
    getUserAssetsData ({ commit }) {
      return new Promise((resolve, reject) => {
        getUserAssetsData().then(response => {
          const res = response.data
          if (res.code === 0) {
            console.log(res.data)
            commit('setUserAssetsData', res.data)
          }
          resolve(response)
        }).catch(responseErr => {
          reject(responseErr)
        })
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js